jQuery(document).ready(function($) {
    let page = 1;
    
    // check for filter changes
    $('#grid-event-selector').change(function(){
        page = 1;
        loadEvents()
    });

    // check for filter changes
    $('#load-more-btn').click(function(){
        page ++;
        loadEvents()
    });

    $('.event-selector__clear-link').on( 'click', function() {
        $('#grid-event-selector').trigger("reset");
        loadEvents()
    });
    
    
    // load the events
    function loadEvents() {
        //console.log('load events');
        let search = document.getElementById('grid-search').value || '';
        let presenter = document.getElementById('grid-series').value || '';
        let genre = document.getElementById('grid-genre').value || '';

        //console.log('load events: ' + search + '/presenter:' + presenter + '/genre:' + genre + '/page: ' + page);
        //return false;
        
        

        $.ajax({
            url: event_object.ajax_url,
            type: 'post',
            data: {
                action: 'load_grid_events',
                nonce: event_object.nonce,
                search: search,
                presenter: presenter,
                grid: event_object.grid,
                genre: genre,
                page: page
            },
            success: function (response) {
                let obj = jQuery.parseJSON( response );
                // empty the grid if this is the first page
                if(page === 1){ document.getElementById('event-grid').innerHTML = '';}
                //console.log(obj);
                
                for (let i = 0; i < obj.events.length; ++i){
                    document.getElementById('event-grid').innerHTML += obj.events[i];
                    
                }
                
                if(obj.total <= page){
                    //console.log('remove load more button');
                    document.getElementById('load-more').style.display = 'none';    
                }else{
                    //console.log('show load more button');
                    document.getElementById('load-more').style.display = 'flex';
                }
                reload_arrows();
                /*let i = 0;
                while (i < slides.length) {
                     mySlider.add(slides[i]);
                     i++;
                 }
                 $('.load-events').removeClass("active");
                 me.addClass("active");*/
                
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log('error');
                console.log(xhr.status);
                console.log(thrownError);
            }
        });
        
        return false;
    }
    
    function reload_arrows() {
        $('a.eb-item__learn').not('.done').each(function(index, element) {
            $(element).addClass('done');
            var heading = $(element), word_array, last_word, first_part;

            word_array = heading.html().trim().split(/\s+/); // split on spaces
            last_word = word_array.pop();             // pop the last word
            first_part = word_array.join(' ');        // rejoin the first words together

            heading.html([first_part, ' <span class="card-lastword learn-link">', last_word, '<span class="card-arrow">&nbsp;&nbsp;<svg role="img" aria-label="arrow" width="9px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.8 17.95"><g><path' +
            ' d="M.9,17.95c-.2,0-.3,0-.4-.1-.3-.2-.5-.5-.5-.9V1.05C0,.65.2.35.5.15.8-.05,1.2-.05,1.4.15l11,8c.5.3.5,1,.2,1.5,0,0,0,.1-.2.2L1.4,17.75c-.1,0-.3.2-.5.2" fill="currentColor" stroke-width="0"></path></g></svg></span></span>'].join(''));
        });
    }

    loadEvents();
});